<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Edit Tariff</h5>
    <form [formGroup]="EditTariff" (submit)="SubmitEditTariff()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Instrument</label>
          <input type="text" class="form-control" disabled value="{{Selected_Price_Record.device_name}}" />
        </div>
      </div>



      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Unit Amount (IRR) - Customer</label>
          <input type="text" disabled value="{{Selected_Price_Record.tariff|number}}" class="form-control"
            placeholder="Type here...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Unit Amount in Words - Customer </label>
          <input disabled type="text" value="{{tariff_Alpha}}" class="form-control">
        </div>

      </div>

      <div class="row">

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Score</label>
          <input type="text" disabled value="{{Selected_Price_Record.tariff_expert|number}}" class="form-control"
            placeholder="Type here...">

        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Expense</label>
          <input type="text" disabled value="{{Selected_Price_Record.tariff_hazineh|number}}" class="form-control"
            placeholder="Type here...">

        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Description</label>
          <input formControlName="Dsc" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched"
            class="form-text text-muted MyErrorRedColor">Enter the description.</small>
        </div>
      </div>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!EditTariff.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
          class="fa fa-times-rectangle"></i> Cancel </button>
      <button routerLink="/Tariff" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
  </div>
</div>